<template>
    <div class="abnormal-arrears">
        <div class="totle-content">
            <div class="select-search">
                <div class="select-group">

                </div>
                <div class="button-group">
                    <el-select v-model="status" filterable placeholder="是否按剩余电量排序"
                               @change="skip=0;limit=20;cur_page=1;arrearsroom()">
                        <el-option
                                v-for="item in options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                    <!--<el-button type="primary" icon="el-icon-search" @click="occupancyrate">搜索</el-button>-->
                    <el-button type="success" icon="el-icon-tickets" @click="downloadMater">导出</el-button>
                </div>

            </div>

            <div class="table-content">
                <el-table class="table-head" :data="arrearsData" border>
                    <el-table-column align="center" type="index" width="50"></el-table-column>
                    <el-table-column align="center" prop="address" label="房源地址" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="room" label="房间名称" show-overflow-tooltip></el-table-column>
                    <el-table-column align="center" prop="surplus" label="剩余电量（度）"></el-table-column>
                    <el-table-column align="center" prop="name" label="租客姓名"></el-table-column>
                    <el-table-column align="center" prop="phone" label="手机号码"></el-table-column>
                    <el-table-column align="center" prop="staydate" label="操作" min-width="50">
                        <template slot-scope="scope">
                            <el-button @click="toHouse(scope.$index, arrearsData)" type="text" size="small">查看
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--分页-->
            <div class="pagination-part">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="cur_page"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="20"
                        layout="total,sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>

        </div>
    </div>
</template>

<script>
    import store from "../store";

    var FileSaver = require('file-saver');

    export default {
        name: "AbnormalArrears",
        data() {
            return {
                arrearsData: [],
                total: 0,
                skip: 0,
                limit: 20,
                cur_page: 1,
                status: '',
                options: [{
                    value: '0',
                    label: '不排序'
                }, {
                    value: '1',
                    label: '排序（加载速度较慢）'
                }],
            }
        },
        mounted() {
            this.arrearsroom();
        },
        methods: {
            //欠费房间
            arrearsroom() {
                if (this.status == 0 || this.status == '') {
                    this.$http.get(`${store.state.url}zone/oweflats/` + this.skip + `/` + this.limit + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                let arrearsData = [];
                                if (res.Data != null) {
                                    for (let i in res.Data) {
                                        arrearsData[i] = {
                                            address: res.Data[i].Addr,
                                            room: res.Data[i].Room,
                                            surplus: res.Data[i].Surplus.toFixed(2),
                                            name: res.Data[i].TenantName,
                                            phone: res.Data[i].TenantPhone,
                                            suiteid: res.Data[i].Suiteid,
                                        }
                                    }
                                }
                                this.arrearsData = arrearsData;
                                this.total = res.Expand;
                            } else {
                                this.arrearsData = [];
                                this.total = 0;
                                this.$message(res.Message);
                            }
                        })
                } else {
                    this.$http.get(`${store.state.url}zone/sortedoweflats/` + this.skip + `/` + this.limit + `?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                        .then((res) => {
                            if (res.Code == 0) {
                                let arrearsData = [];
                                if (res.Data != null) {
                                    for (let i in res.Data) {
                                        arrearsData[i] = {
                                            address: res.Data[i].Addr,
                                            room: res.Data[i].Room,
                                            surplus: res.Data[i].Surplus.toFixed(2),
                                            name: res.Data[i].TenantName,
                                            phone: res.Data[i].TenantPhone,
                                            suiteid: res.Data[i].Suiteid,
                                        }
                                    }
                                }
                                this.arrearsData = arrearsData;
                                this.total = res.Expand;
                            } else {
                                this.arrearsData = [];
                                this.total = 0;
                                this.$message(res.Message);
                            }
                        })
                }

            },

            //分页
            handleSizeChange(val) {
                this.limit = val;
                this.arrearsroom();
            },
            handleCurrentChange(val) {
                this.skip = (val - 1) * this.limit;
                this.arrearsroom();
            },
            toHouse(index, row) {
                let sid = row[index].suiteid,
                    tableInfo = {};
                tableInfo.table = 0;
                tableInfo.index = '2';
                window.localStorage.sid = sid;

                this.$router.push('./house');
            },

            //导出1000条数据
            downloadData() {
                return new Promise((resolve, reject) => {
                    let arrearsData = [];
                    if (this.status == 0 || this.status == '') {
                        this.$http.get(`${store.state.url}zone/oweflats/0/1000?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                            .then((res) => {
                                if (res.Code == 0) {
                                    if (res.Data != null) {
                                        for (let i in res.Data) {
                                            arrearsData[i] = {
                                                address: res.Data[i].Addr,
                                                room: res.Data[i].Room,
                                                surplus: res.Data[i].Surplus.toFixed(2),
                                                name: res.Data[i].TenantName,
                                                phone: res.Data[i].TenantPhone,
                                            }
                                        }
                                        resolve(arrearsData);
                                    }
                                }
                            })
                    } else {
                        this.$http.get(`${store.state.url}zone/sortedoweflats/0/1000?uid=${window.localStorage.uid}&token=${window.localStorage.token}`)
                            .then((res) => {
                                if (res.Code == 0) {
                                    if (res.Data != null) {
                                        for (let i in res.Data) {
                                            arrearsData[i] = {
                                                address: res.Data[i].Addr,
                                                room: res.Data[i].Room,
                                                surplus: res.Data[i].Surplus.toFixed(2),
                                                name: res.Data[i].TenantName,
                                                phone: res.Data[i].TenantPhone,
                                            }
                                        }
                                        resolve(arrearsData);
                                    }
                                }
                            })
                    }
                })
            },

            //导出excel
            downloadMater() {
                this.downloadData().then((arrearsData) => {
                    const defaultCellStyle = {
                        font: {name: "Verdana", sz: 11, color: "FF00FF88"},
                        fill: {fgColor: {rgb: "FFFFAA00"}}
                    };
                    const wopts = {
                        bookType: 'xlsx',
                        bookSST: false,
                        type: 'binary',
                        defaultCellStyle: defaultCellStyle,
                        showGridLines: false
                    };
                    const wb = {SheetNames: ['Sheet1'], Sheets: {}, Props: {}};

                    let Data = [];
                    for (let i = 0; i < arrearsData.length; i++) {
                        console.log(i)
                        Data[i] = {
                            房源地址: arrearsData[i].address,
                            房间名称: arrearsData[i].room,
                            剩余电量: arrearsData[i].surplus,
                            租客姓名: arrearsData[i].name,
                            手机号码: arrearsData[i].phone,
                        };
                    }
                    let data = Data;
                    wb.Sheets['Sheet1'] = XLSX.utils.json_to_sheet(data);

                    //创建二进制对象写入转换好的字节流
                    let tmpDown = new Blob([this.s2ab(XLSX.write(wb, wopts))], {type: "application/octet-stream"})
                    FileSaver.saveAs(tmpDown, "欠费房间报表.xls");
                });
            },
            //字符串转字符流
            s2ab(s) {
                if (typeof ArrayBuffer !== 'undefined') {
                    var buf = new ArrayBuffer(s.length);
                    var view = new Uint8Array(buf);
                    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                } else {
                    var buf = new Array(s.length);
                    for (var i = 0; i != s.length; ++i) buf[i] = s.charCodeAt(i) & 0xFF;
                    return buf;
                }
            },
        }
    }
</script>

<style scoped>
    .el-select {
        width: 2.2rem;
    }
</style>